import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ILandingOrigen } from '../../types/LandingOrigen';
import { EnvConfig } from '../../types/EnvConfig';

interface OrigenState {
  lastLoaded: number | null;
  envConfig: EnvConfig|undefined;  
  origenData: ILandingOrigen;
  setEnvConfig: (data: EnvConfig) => void;
  setOrigen: (data: ILandingOrigen) => void;
  resetOrigen: () => void;
}

export const useOrigenStore = create<OrigenState>()(
  persist(
    (set) => ({
      lastLoaded: null,
      envConfig: undefined,
      origenData: {
        origen: 'SEGURARSE',
        logo: '',
        bgColor: '',
        riegos: [],
        riesgoData: [],
        rutas: [],
        ready: false,
        home_root: true
      },
      setEnvConfig: (data) => set({
        envConfig: data,
        lastLoaded: Date.now()
      }),
      setOrigen: (data) => set({ origenData: data }),
      resetOrigen: () =>
        set({
          origenData: {
            origen: 'SEGURARSE',
            logo: '',
            bgColor: '',
            riegos: [],
            riesgoData: [],
            rutas: [],
            ready: false,
            home_root: true
          },
        }),
    }),
    {
      name: 'origen-storage',
      getStorage: () => localStorage,
    }
  )
);
